module.exports = __webpack_public_path__ + "static/img/BRETT_LEE.435243f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BRETT_LEE.jpg
// module id = Sdgw
// module chunks = 0